/* BeeDTF · UV DTF stickers by size
   Same flow and look as Transfers by Size: upload -> pick a fixed size (sticker or cup wrap) -> quantity.
   Every variant is one size: 'W"xH"' or 'W"xH - 16 Oz Glass Wrap'. Bulk tiers count every sticker in the order. */
(() => {
  const ICON_CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>';
  const ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  const IN = '″';
  const SESSION = (() => {
    try { const s = JSON.parse(localStorage.getItem('bee_session') || 'null'); if (s && s.id && Date.now() - s.t < 7 * 864e5) return s.id; } catch (e) { /* ignore */ }
    const id = 'S' + Math.random().toString(36).slice(2, 8).toUpperCase();
    try { localStorage.setItem('bee_session', JSON.stringify({ id, t: Date.now() })); } catch (e) { /* ignore */ }
    return id;
  })();

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-json]').textContent);
    const addUrl = root.dataset.addUrl || '/cart/add';
    const cartUrl = root.dataset.cartUrl || '/cart';
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' });
    const fmt = (c) => money.format(c / 100);
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const $ = (s) => root.querySelector(s);
    const num = (n) => String(Math.round(n * 100) / 100);

    /* ---------- sizes from variants ---------- */
    /* option1 = size, option2 (optional) = finish: "Roll (uncut)" / "Pre-cut" */
    const sizes = [];
    data.variants.forEach((v) => {
      const name = String(v.option1 || '');
      const m = name.match(/^\s*([\d.]+)\s*["″]?\s*[x×]\s*([\d.]+)\s*["″]?\s*(?:-\s*(.+))?$/i);
      if (!m) return;
      const pre = /pre/i.test(String(v.option2 || ''));
      let s = sizes.find((x) => x.name === name);
      if (!s) {
        const label = (m[3] || '').trim();
        s = { id: null, name, w: parseFloat(m[1]), h: parseFloat(m[2]), label, wrap: !!label, price: 0, available: false, roll: null, pre: null };
        sizes.push(s);
      }
      const opt = { id: v.id, price: v.price, available: v.available };
      if (pre) s.pre = opt; else s.roll = opt;
      const base = s.roll || s.pre;
      s.id = base.id; s.price = base.price; s.available = base.available;
    });
    const hasPrecut = sizes.some((s) => s.pre && s.roll);
    const precutFee = hasPrecut ? (() => { const s = sizes.find((x) => x.pre && x.roll); return s.pre.price - s.roll.price; })() : 0;
    const varOf = (d) => (d.size ? ((d.fin === 'precut' && d.size.pre) ? d.size.pre : (d.size.roll || d.size.pre)) : null);
    const squares = sizes.filter((s) => !s.wrap);
    const wraps = sizes.filter((s) => s.wrap);
    const byId = (id) => sizes.find((s) => String(s.id) === String(id));
    const defaultSize = sizes.find((s) => s.name === data.defaultSize) || squares[Math.min(2, squares.length - 1)] || sizes[0];
    const selV = data.selected ? data.variants.find((v) => String(v.id) === String(data.selected)) : null;
    const wrapTitle = (s) => s.label.replace(/\boz\b/i, 'oz').replace(/\s+wrap$/i, '');

    const breaks = (data.tiers || []).filter((t) => t && t.qty > 0).sort((a, b) => a.qty - b.qty);
    /* a tier with a cap only counts and discounts square stickers up to cap inches (wraps excluded) */
    const okFor = (s, t) => !!s && (!t.cap || (!s.wrap && Math.max(s.w, s.h) <= t.cap));
    const countFor = (t) => designs.reduce((a, d) => a + (okFor(d.size, t) ? d.qty : 0), 0);
    /* Shopify applies ONE bulk discount per cart (they don't combine): the reached tier that saves the most in total.
       Sizes that tier doesn't cover get no bulk discount. */
    const saveOf = (t) => designs.reduce((a, d) => { const v = d.size && okFor(d.size, t) ? varOf(d) : null; return a + (v ? v.price * d.qty * t.pct : 0); }, 0);
    const bestTier = () => breaks.filter((t) => countFor(t) >= t.qty).reduce((b, t) => (!b || saveOf(t) > saveOf(b) ? t : b), null);
    const pctOf = (d) => { const t = bestTier(); return t && okFor(d.size, t) ? t.pct : 0; };
    const tierInfo = () => {
      const cur = bestTier() || { qty: 0, pct: 0 };
      const next = breaks.find((t) => t.qty > cur.qty && countFor(t) < t.qty) || null;
      return { cur, next };
    };

    /* ---------- elements ---------- */
    const form = $('[data-form]');
    const fileInput = $('[data-file]');
    const drop = $('[data-drop]');
    const dropTitle = $('[data-drop-title]');
    const list = $('[data-list]');
    const dropHome = document.createComment('drop');
    drop.before(dropHome);
    const bulk = $('[data-bulk]');
    const nudge = $('[data-nudge]');
    const breaksEl = $('[data-breaks]');
    const totalEl = $('[data-total]');
    const totalMeta = $('[data-total-meta]');
    const addBtn = $('[data-add]');
    const addLabel = $('[data-add-label]');
    const addText = addLabel.textContent;
    const errFile = $('[data-err="file"]');
    const errSubmit = $('[data-err="submit"]');
    const stage = $('[data-stage]');
    const preview = $('[data-preview]');
    const previewImg = $('[data-preview-img]');
    const previewName = $('[data-preview-name]');
    const cap = $('[data-cap]');
    const dimW = $('[data-dim-w]');
    const dimH = $('[data-dim-h]');
    const bar = $('[data-bar]');
    const barTotal = bar && bar.querySelector('[data-bar-total]');
    const barInfo = bar && bar.querySelector('[data-bar-info]');
    const barBtn = bar && bar.querySelector('[data-bar-btn]');

    /* ---------- uploads: big files go to Google Drive, a small preview goes to Shopify ---------- */
    const SHOPIFY_MAX = 20 * 1024 * 1024;
    const SMALL_MAX = 35 * 1024 * 1024;
    const up = data.upload || {};
    const productName = String(((root.querySelector('h1') || {}).textContent || data.product || 'UV DTF stickers')).trim().replace(/\s+/g, ' ').slice(0, 60);
    const mb = (b) => `${(b / 1048576).toFixed(b < 10485760 ? 1 : 0)} MB`;
    const post = (body) => fetch(up.url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ key: up.key, ...body }) }).then((r) => r.json());
    const putFile = (url, file, onp) => new Promise((resolve, reject) => {
      const x = new XMLHttpRequest();
      x.open('PUT', url);
      x.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
      x.upload.onprogress = (e) => { if (e.lengthComputable) onp(e.loaded / e.total); };
      x.onload = () => {
        if (x.status === 200 || x.status === 201) { try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); } }
        else reject(new Error(`Upload failed (${x.status})`));
      };
      x.onerror = () => reject(new Error('Upload blocked'));
      x.send(file);
    });
    const toB64 = (file) => new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result).split(',')[1] || '');
      r.onerror = reject;
      r.readAsDataURL(file);
    });
    const paintUp = (d) => {
      const j = d.job;
      const el = d.el && d.el.querySelector('[data-c-up]');
      if (!el) return;
      const state = j ? j.state : '';
      el.className = `bee-bs__up is-${state}`;
      el.textContent = !j ? '' : state === 'busy' ? `Bzzz… uploading your file ${Math.round(j.pct * 100)}%`
        : state === 'done' ? `✓ File uploaded (${mb(j.file.size)})`
        : state === 'error' ? (j.file.size > SHOPIFY_MAX ? 'Upload failed. Please remove this file and try again.' : '') : '';
      const b = d.el.querySelector('[data-c-bar]');
      if (b) b.style.setProperty('--p', state === 'done' ? 1 : (j ? j.pct : 0));
      d.el.classList.toggle('is-uploading', state === 'busy');
    };
    const startUpload = (d) => {
      const file = d.file;
      const job = { file, state: 'busy', pct: 0 };
      const set = (state, pct) => { job.state = state; job.pct = pct || 0; if (d.job === job) paintUp(d); };
      job.promise = (async () => {
        const base = { ref: d.ref, session: SESSION, name: file.name, type: file.type || 'application/octet-stream', size: file.size, origin: location.origin, product: productName, label: '' };
        try {
          const ini = await post({ action: 'init', ...base });
          if (!ini.ok) throw new Error(ini.error || 'init');
          const res = await putFile(ini.uploadUrl, file, (p) => set('busy', p * 0.99));
          if (!res.id) throw new Error('No file id');
          set('done', 1);
          return `https://drive.google.com/file/d/${res.id}/view`;
        } catch (e1) {
          if (file.size > SMALL_MAX) { set('error'); throw e1; }
          try {
            set('busy', 0.3);
            const r = await post({ action: 'small', ...base, data: await toB64(file) });
            if (!r.ok) throw new Error(r.error || 'small');
            set('done', 1);
            return r.url;
          } catch (e2) { set('error'); throw e2; }
        }
      })();
      job.promise.catch(() => {});
      return job;
    };

    /* ---------- designs ---------- */
    const designs = [];
    let activeKey = null;
    let seq = 0;
    const isImage = (f) => /^image\/(png|jpe?g|webp|svg\+xml)$/i.test(f.type || '');
    const makeThumb = (url) => new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const k = Math.min(1, 600 / Math.max(img.naturalWidth || 600, img.naturalHeight || 600));
        const c = document.createElement('canvas');
        c.width = Math.max(1, Math.round((img.naturalWidth || 600) * k));
        c.height = Math.max(1, Math.round((img.naturalHeight || 600) * k));
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob((b) => resolve(b), 'image/png');
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    const addFiles = (files) => {
      Array.from(files || []).forEach((file) => {
        const d = { key: `d${++seq}`, ref: `${SESSION}-${Date.now().toString(36).slice(-4).toUpperCase()}${seq}`, file, name: file.name, size: defaultSize, fin: (data.defaultFin === 'precut' && hasPrecut) ? 'precut' : 'roll', qty: 1, notes: '', px: null, url: null };
        if (isImage(file)) {
          d.url = URL.createObjectURL(file);
          const img = new Image();
          img.onload = () => { if (!/svg/i.test(file.type)) d.px = { w: img.naturalWidth, h: img.naturalHeight }; render(); };
          img.src = d.url;
          d.thumb = makeThumb(d.url);
        }
        if (!up.url && file.size > SHOPIFY_MAX) d.tooBig = true;
        designs.push(d);
        activeKey = d.key;
        if (up.url) d.job = startUpload(d);
      });
      fileInput.value = '';
      errFile.hidden = true;
      drop.classList.remove('is-missing');
      render();
    };

    /* the design fills the size box and keeps its shape */
    const fitOf = (d) => {
      const s = d.size;
      if (!s) return null;
      if (!d.px) return { w: s.w, h: s.h };
      const r = d.px.w / d.px.h;
      return r >= s.w / s.h ? { w: s.w, h: s.w / r } : { w: s.h * r, h: s.h };
    };
    const quality = (d) => {
      const f = fitOf(d);
      if (!d.px || !f) return '';
      const dpi = Math.min(d.px.w / f.w, d.px.h / f.h);
      const sharp = Math.max(d.px.w, d.px.h) / (data.dpi || 300);
      if (dpi < 150) return `<span class="bee-bs__warn">Your file is ${d.px.w} × ${d.px.h} px, so it may look blurry at this size (${Math.round(dpi)} DPI). It prints sharp up to about ${num(sharp)}${IN}. We'll check it and email you before printing.</span>`;
      return `<span class="bee-st__ok">Prints at ${num(f.w)}${IN} × ${num(f.h)}${IN} · ${Math.round(dpi)} DPI, looks sharp.</span>`;
    };

    /* ---------- markup ---------- */
    const chip = (d, s) => `<button type="button" class="bee-bs__chip" data-size="${s.id}" aria-pressed="${d.size && d.size.id === s.id}" ${s.available ? '' : 'disabled'}><strong>${s.wrap ? esc(wrapTitle(s)) : `${num(s.w)}${IN}`}</strong><small>${fmt(s.price)}</small></button>`;
    const g = data.groups || {};
    const cardHTML = (d, n) => `
      <header class="bee-bs__card-head">
        <span class="bee-bs__num">${n}</span>
        <span class="bee-bs__thumb">${d.url ? `<img src="${d.url}" alt="">` : esc((d.name.split('.').pop() || 'FILE').toUpperCase().slice(0, 4))}</span>
        <div class="bee-bs__card-meta"><strong title="${esc(d.name)}">${esc(d.name)}</strong><small data-c-sum></small><small class="bee-bs__up" data-c-up></small></div>
        <strong class="bee-bs__card-price" data-c-price></strong>
        <button type="button" class="bee-bs__icon-btn" data-c-toggle aria-expanded="true" aria-label="Show or hide options">${ICON_CHEV}</button>
        <button type="button" class="bee-bs__icon-btn" data-c-remove aria-label="Remove ${esc(d.name)}">${ICON_X}</button>
        <span class="bee-bs__bar-up" data-c-bar aria-hidden="true"></span>
      </header>
      <div class="bee-bs__card-body">
        <p class="bee-bs__measure" data-c-measure></p>
        ${squares.length ? `<div class="bee-bs__group"><div class="bee-bs__group-head">${esc(g.squares || 'Sticker size')}<small>${esc(g.squaresSub || '')}</small></div><div class="bee-bs__chips">${squares.map((s) => chip(d, s)).join('')}</div></div>` : ''}
        ${wraps.length ? `<div class="bee-bs__group"><div class="bee-bs__group-head">${esc(g.wraps || 'Cup wraps')}<small>${esc(g.wrapsSub || '')}</small></div><div class="bee-bs__chips bee-bs__chips--wrap">${wraps.map((s) => chip(d, s)).join('')}</div></div>` : ''}
        <p class="bee-bs__note" data-c-note></p>
        ${hasPrecut ? `<div class="bee-bs__label">Finish</div>
        <div class="bee-bs__seg" role="group" aria-label="Finish">
          <button type="button" data-c-fin="roll" aria-pressed="true">Roll (uncut)</button>
          <button type="button" data-c-fin="precut" aria-pressed="false">Pre-cut<small>+${fmt(precutFee)}</small></button>
        </div>` : ''}
        <div class="bee-bs__label">Quantity</div>
        <div class="bee-bs__qtyline">
          <div class="bee-bs__qty"><button type="button" data-q="-1" aria-label="Fewer">−</button><input type="number" min="1" max="9999" inputmode="numeric" value="${d.qty}" aria-label="Quantity" data-c-qty><button type="button" data-q="1" aria-label="More">+</button></div>
          <div class="bee-bs__each" data-c-each></div>
        </div>
        <details class="bee-bs__instr"><summary>Add instructions (optional)</summary><textarea data-c-notes placeholder="E.g. remove the white background, cut close to the design…">${esc(d.notes)}</textarea></details>
      </div>`;

    const lineOf = (d, pct) => {
      const v = varOf(d);
      if (!v) return 0;
      return Math.round(v.price * d.qty * (1 - pct / 100));
    };

    const paintPreview = () => {
      const d = designs.find((x) => x.key === activeKey) || designs[designs.length - 1];
      if (!d) { preview.hidden = true; stage.classList.remove('has-design'); return; }
      stage.classList.add('has-design');
      preview.hidden = false;
      const f = fitOf(d);
      if (d.url) { previewImg.src = d.url; previewImg.hidden = false; } else { previewImg.removeAttribute('src'); previewImg.hidden = true; }
      dimW.textContent = f ? `${num(f.w)}${IN}` : '';
      dimH.textContent = f ? `${num(f.h)}${IN}` : '';
      previewName.textContent = d.name;
      cap.innerHTML = d.size ? `<strong>${d.size.wrap ? esc(d.size.label) : 'Sticker'}</strong> · ${num(d.size.w)}${IN} × ${num(d.size.h)}${IN}${d.url ? '' : ' · preview shows after we check your file'}` : '';
    };

    const render = () => {
      const Q = designs.reduce((a, d) => a + (d.size ? d.qty : 0), 0);
      const { cur, next } = tierInfo();
      // cards
      const keys = new Set(designs.map((d) => d.key));
      Array.from(list.children).forEach((el) => { if (!keys.has(el.dataset.key)) el.remove(); });
      designs.forEach((d, i) => {
        if (!d.el) {
          d.el = document.createElement('article');
          d.el.className = 'bee-bs__card is-open';
          d.el.dataset.key = d.key;
          d.el.innerHTML = cardHTML(d, i + 1);
          list.appendChild(d.el);
          paintUp(d);
        }
        d.el.querySelector('.bee-bs__num').textContent = i + 1;
        d.el.classList.toggle('is-active', d.key === activeKey);
        d.el.querySelectorAll('[data-size]').forEach((b) => b.setAttribute('aria-pressed', String(!!d.size && String(d.size.id) === b.dataset.size)));
        d.el.querySelectorAll('[data-c-fin]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cFin === d.fin)));
        const vv = varOf(d);
        const lp = pctOf(d);
        const each = vv ? Math.round(vv.price * (1 - lp / 100)) : 0;
        d.el.querySelector('[data-c-sum]').textContent = d.size ? `${d.size.wrap ? d.size.label : `${num(d.size.w)}${IN} × ${num(d.size.h)}${IN} sticker`}${hasPrecut ? ` · ${d.fin === 'precut' ? 'Pre-cut' : 'Roll'}` : ''} · ${d.qty} pcs` : 'Pick a size';
        d.el.querySelector('[data-c-price]').textContent = d.size ? fmt(lineOf(d, lp)) : '';
        d.el.querySelector('[data-c-each]').innerHTML = d.size ? `${fmt(each)} each${lp ? ` <small>(−${lp}%)</small>` : ''}` : '';
        d.el.querySelector('[data-c-note]').innerHTML = quality(d);
        d.el.querySelector('[data-c-measure]').innerHTML = d.tooBig ? `<span class="bee-bs__warn">This file is ${mb(d.file.size)}. The limit is 20 MB, so please upload a smaller file.</span>` : '';
        const qi = d.el.querySelector('[data-c-qty]');
        if (document.activeElement !== qi) qi.value = d.qty;
      });
      // drop zone
      drop.classList.toggle('is-compact', designs.length > 0);
      dropTitle.textContent = designs.length ? 'Add another design' : 'Upload your design';
      if (designs.length && list.nextElementSibling !== drop) list.after(drop);
      else if (!designs.length && dropHome.nextSibling !== drop) dropHome.after(drop);
      // bulk
      bulk.hidden = !designs.length || !breaks.length;
      if (!bulk.hidden) {
        breaksEl.innerHTML = `<li class="${cur.pct === 0 ? 'is-on' : ''}"><strong>1+</strong><span>Base price</span></li>`
          + breaks.map((t) => `<li class="${cur.qty === t.qty ? 'is-on' : ''}${next && next.qty === t.qty ? ' is-next' : ''}"><strong>${t.qty}+</strong><span>${t.pct}% off${t.cap ? ` · up to ${t.cap}${IN}` : ''}</span></li>`).join('');
        if (next && Q > 0) {
          const need = next.qty - countFor(next);
          nudge.innerHTML = `<p><strong>Add ${need} more to get ${next.pct}% off</strong>${next.cap ? `Stickers up to ${next.cap}${IN} count` : 'All stickers in this order count'}: ${countFor(next)} now, ${next.qty} needed.</p>`;
        } else if (cur.pct) {
          nudge.innerHTML = `<p><strong>${cur.pct}% bulk discount unlocked</strong>Applied automatically in your cart.</p>`;
        } else nudge.innerHTML = '';
      }
      // total
      const total = designs.reduce((a, d) => a + lineOf(d, pctOf(d)), 0);
      if (designs.length) {
        totalEl.textContent = fmt(total);
        totalMeta.textContent = `${Q} sticker${Q === 1 ? '' : 's'} · ${designs.length} design${designs.length === 1 ? '' : 's'}${cur.pct ? ` · ${cur.pct}% off` : ''}`;
      } else {
        totalEl.textContent = fmt(selV ? selV.price : (squares.length ? squares[0].price : 0));
        totalMeta.textContent = 'Upload a design to see pricing';
      }
      if (barTotal) barTotal.textContent = totalEl.textContent;
      if (barInfo) barInfo.textContent = designs.length ? totalMeta.textContent : 'UV DTF stickers';
      paintPreview();
    };

    /* ---------- events ---------- */
    fileInput.addEventListener('change', () => addFiles(fileInput.files));
    ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
    drop.addEventListener('drop', (e) => { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });

    list.addEventListener('click', (e) => {
      const card = e.target.closest('.bee-bs__card');
      if (!card) return;
      const d = designs.find((x) => x.key === card.dataset.key);
      if (!d) return;
      activeKey = d.key;
      const sb = e.target.closest('[data-size]');
      if (sb && !sb.disabled) { d.size = byId(sb.dataset.size); render(); return; }
      const fb = e.target.closest('[data-c-fin]');
      if (fb) { d.fin = fb.dataset.cFin; render(); return; }
      const qb = e.target.closest('[data-q]');
      if (qb) { d.qty = Math.max(1, Math.min(9999, d.qty + parseInt(qb.dataset.q, 10))); render(); return; }
      if (e.target.closest('[data-c-toggle]')) {
        const open = !card.classList.contains('is-open');
        card.classList.toggle('is-open', open);
        card.querySelector('[data-c-toggle]').setAttribute('aria-expanded', String(open));
        return;
      }
      if (e.target.closest('[data-c-remove]')) {
        designs.splice(designs.indexOf(d), 1);
        if (d.url) URL.revokeObjectURL(d.url);
        if (activeKey === d.key) activeKey = designs.length ? designs[designs.length - 1].key : null;
        render();
        return;
      }
      render();
    });
    list.addEventListener('input', (e) => {
      const card = e.target.closest('.bee-bs__card');
      const d = card && designs.find((x) => x.key === card.dataset.key);
      if (!d) return;
      if (e.target.matches('[data-c-qty]')) { d.qty = Math.max(1, Math.min(9999, parseInt(e.target.value, 10) || 1)); render(); }
      if (e.target.matches('[data-c-notes]')) d.notes = e.target.value;
    });

    /* mobile sticky bar */
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-shown', show);
        bar.setAttribute('aria-hidden', String(!show));
        if (barBtn) barBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      if (barBtn) barBtn.addEventListener('click', () => { if (designs.length) form.requestSubmit ? form.requestSubmit() : addBtn.click(); else drop.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* ---------- add to cart ---------- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errSubmit.hidden = true;
      if (!designs.length) {
        errFile.hidden = false;
        drop.classList.add('is-missing');
        drop.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const bad = designs.find((d) => !d.size || d.tooBig);
      if (bad) {
        activeKey = bad.key;
        render();
        bad.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errSubmit.textContent = bad.tooBig ? `${bad.name} is too large. Please upload a file under 20 MB.` : 'Pick a size for every design.';
        errSubmit.hidden = false;
        return;
      }
      addBtn.classList.add('is-busy');
      try {
        for (let i = 0; i < designs.length; i++) {
          const d = designs[i];
          addLabel.innerHTML = `<span class="bee-buzz">Bzzz…</span> ${designs.length > 1 ? `sending design ${i + 1} of ${designs.length}` : 'sending your design'}`;
          let driveUrl = null;
          if (d.job) {
            const tick = setInterval(() => {
              if (d.job.state === 'busy') addLabel.innerHTML = `<span class="bee-buzz">Bzzz…</span> sending ${designs.length > 1 ? `design ${i + 1} of ${designs.length}` : 'your design'} ${Math.round(d.job.pct * 100)}%`;
            }, 250);
            try { driveUrl = await d.job.promise; } catch (er) { driveUrl = null; }
            clearInterval(tick);
          }
          if (!driveUrl && d.file.size > SHOPIFY_MAX) throw new Error(`${d.name} (${mb(d.file.size)}) could not be uploaded. Please check your connection and try again, or contact us.`);
          const f = fitOf(d);
          const fd = new FormData();
          fd.append('id', varOf(d).id);
          fd.append('quantity', d.qty);
          fd.append('properties[Size]', d.size.name);
          if (hasPrecut) fd.append('properties[Finish]', d.fin === 'precut' ? 'Pre-cut' : 'Roll (uncut)');
          if (f && d.px) fd.append('properties[Prints at]', `${num(f.w)}${IN} × ${num(f.h)}${IN}`);
          if (driveUrl) {
            const thumb = d.thumb ? await d.thumb : null;
            if (thumb) fd.append('properties[Design]', new File([thumb], `preview-${d.name.replace(/\.[^.]+$/, '')}.png`, { type: 'image/png' }));
            else fd.append('properties[Design]', d.name);
            fd.append('properties[_Print file]', driveUrl);
            fd.append('properties[_File name]', `${d.file.name} (${mb(d.file.size)})`);
          } else {
            fd.append('properties[Design]', d.file);
          }
          fd.append('properties[_Ref]', d.ref);
          if (d.notes && d.notes.trim()) fd.append('properties[Instructions]', d.notes.trim());
          const res = await fetch(`${addUrl}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) {
            const j = await res.json().catch(() => ({}));
            throw new Error(`${d.name}: ${j.description || 'could not be added to the cart.'}`);
          }
        }
        location.href = cartUrl;
      } catch (ex) {
        errSubmit.textContent = ex.message;
        errSubmit.hidden = false;
        addBtn.classList.remove('is-busy');
        addLabel.textContent = addText;
      }
    });

    if (!document.getElementById('bee-buzz-css')) { const st = document.createElement('style'); st.id = 'bee-buzz-css'; st.textContent = '.bee-buzz{display:inline-block;animation:bee-buzz .18s linear infinite}@keyframes bee-buzz{0%,100%{transform:translate(0,0) rotate(0)}25%{transform:translate(.7px,-.6px) rotate(-2deg)}50%{transform:translate(-.6px,.5px) rotate(1.5deg)}75%{transform:translate(.5px,.7px) rotate(-1deg)}}@media (prefers-reduced-motion:reduce){.bee-buzz{animation:none}}'; document.head.appendChild(st); }
    render();
  };
  const boot = () => document.querySelectorAll('.bee-st').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
